
<app-enfaf-modal
  svgIcon="mail"
  [title]="'Editar email de finalización de curso: ' + courseName"
  buttonCancelText="Cancelar"
  (onClose)="confirmCloseModal()"
  buttonConfirmText="Enviar"
  (onConfirm)="saveEmail()"
  [isLoading]="isSavingEmail"
  [disableConfirmButton]="emailForm.invalid || isSavingEmail"
>

 <form class="modal-content" [formGroup]="emailForm" autocomplete="off">

      <enfaf-input 
        color="light"
        label="Asunto"
        placeholder="Asunto"
        [control]="emailForm.controls.subject"
        name="subject"
        autocomplete="off"
        type="text"
        errorLabel="Asunto requerido"
      />

      <app-enfaf-textarea-light 
        label="Mensaje"
        placeholder="Mensaje"
        [control]="emailForm.controls.message"
        name="message"
        [rows]="10"
        autocomplete="off"
        errorLabel="Mensaje requerido"
      />

      <app-enfaf-input-file-dragger-light
        [acceptMultiple]="true"
        [acceptLimit]="10"
        [maxFileSize]="25000000"
        [accept]="'*'"
        [currentFiles]="currentAttachments"
        (currentFileDeleted)="confirmDeleteAttachment($event)"
        (filesDropped)="onDroppedFiles($event)">
      </app-enfaf-input-file-dragger-light>

    </form>

</app-enfaf-modal>

